import { createTheme } from '@mui/material/styles';
import * as locales from '@mui/material/locale';
import '../index.css';

declare module '@mui/material/styles' {
  interface Palette {
    custom: {
      rose: '#eb8a93';
      leftMenuBg: '#1d507a';
      leftMenuItemHover: '#447395';
      lightBlue: '#c6ebff';
      transparentWhite: 'rgba(255, 255, 255, 0.6)';
      tooltipBg: '#d6ecf1';
    };
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    custom?: {
      rose: '#eb8a93';
      leftMenuBg: '#1d507a';
      leftMenuItemHover: '#447395';
      lightBlue: '#c6ebff';
      transparentWhite: 'rgba(255, 255, 255, 0.6)';
      tooltipBg: '#d6ecf1';
    };
  }
}

// Update the Button's color prop options
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    custom: true;
  }
}

export const mdTheme = createTheme(
  {
    palette: {
      custom: {
        rose: '#eb8a93',
        leftMenuBg: '#1d507a',
        leftMenuItemHover: '#447395',
        lightBlue: '#c6ebff',
        transparentWhite: 'rgba(255, 255, 255, 0.6)',
        tooltipBg: '#d6ecf1',
      },
      primary: {
        main: '#2B3B4A',
      },
    },
    typography: {
      fontSize: 12,
      fontFamily: 'TildaSans',
    },
  },
  locales['ruRU']
);
